import React from "react";
import SectionEyebrow from "./SectionEyebrow";

/**
 * tone: 'light' (dark bg, light text) | 'dark' (light bg, dark text)
 */
const PillarCard = ({ num, title, body, tone = "light", testId }) => {
  const isLight = tone === "light";
  return (
    <article
      className={`pillar-card p-8 md:p-10 ${
        isLight
          ? "bg-galactico/[0.03] text-galactico border border-galactico/15"
          : "bg-galactico text-dodgers border border-dodgers/15"
      }`}
      data-testid={testId}
    >
      <SectionEyebrow num={num}>{title}</SectionEyebrow>
      <h3 className="font-display text-2xl md:text-[2rem] leading-tight mt-5 mb-5">
        {title}
      </h3>
      <p className="text-[1.0625rem] leading-relaxed opacity-90 mb-10">{body}</p>
      <span className="block h-[2px] w-12 bg-lime" />
    </article>
  );
};

export default PillarCard;
